import { DirectionalStyleSheetBehavior, display, focusVisible, forcedColorsStylesheetBehavior, } from "@microsoft/fast-foundation";
import { neutralForegroundHintBehavior, neutralForegroundRestBehavior, } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
import { SystemColors } from "@microsoft/fast-web-utilities";
const ltrStyles = css `
    .hover-actions {
        right: 8px;
    }

    .icon {
        left: 0;
    }

    :host([layout="default"]) .media-wrapper {
        float: right;
    }

    :host([layout="infoPane1x3y"]) ::slotted([slot="content-indicator"]),
    :host([layout="infoPane"]) ::slotted([slot="content-indicator"]),
    .media-wrapper ::slotted([slot="content-indicator"]) {
        left: 8px;
    }
`;
const rtlStyles = css `
    .hover-actions {
        left: 8px;
    }

    .icon {
        right: 0;
    }

    :host([layout="default"]) .media-wrapper {
        float: left;
    }

    :host([layout="infoPane1x3y"]) ::slotted([slot="content-indicator"]),
    :host([layout="infoPane"]) ::slotted([slot="content-indicator"]),
    .media-wrapper ::slotted([slot="content-indicator"]) {
        right: 8px;
    }
`;
export const ContentCardStyles = css `
    ${display("flex")} :host {
        --icon-size: 24px;
        position: relative;
        width: auto;
        box-sizing: border-box;
        font-family: var(--body-font);
        flex-direction: column;
        outline: none;
        height: 100%;
        overflow: hidden;
    }

    :host(:hover) .hover-actions {
        opacity: 1;
        transition: opacity 0.2s ease-in-out;
    }

    :host(:hover) .background-image,
    :host(:hover) .media {
        filter: brightness(0.9);
    }

    .body {
        display: grid;
        justify-content: center;
        row-gap: 8px;
        column-gap: 10px;
        grid-template-columns: 1fr auto;
        grid-template-rows: auto;
    }

    :host([layout="default"]) .body .abstract {
        display: none;
    }

    :host([layout="default"]) .body {
        display: block;
    }

    :host([layout="default"]) .has-abstract .heading {
        -webkit-line-clamp: var(--heading-max-lines, 2);
    }

    :host([layout="default"]) .has-abstract .media-wrapper {
        margin-inline-start: 16px;
    }

    :host([image-priority]) .has-abstract .media-wrapper {
        margin-inline-start: 0;
    }

    .footer {
        padding-inline-start: var(--footer-start-padding, 16px);
        padding-inline-end: var(--footer-start-padding, 16px);
        padding-top: var(--footer-padding-top, 0);
        padding-bottom: var(--footer-padding-bottom, 4px);
        margin-top: auto;
        font-size: var(--footer-font-size, var(--type-ramp-minus-1-font-size));
        line-height: var(--footer-line-height, var(--type-ramp-minus-1-line-height));
    }

    .footer,
    .start-actions,
    .end-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        color: ${neutralForegroundHintBehavior.var};
        fill: ${neutralForegroundHintBehavior.var};
    }

    .footer__hidden {
        display: none;
    }

    .hover-actions {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 8px;
        z-index: 2;
        opacity: 0;
    }

    .hover-actions__hidden {
        display: none;
    }

    .hover-actions:focus-within {
        opacity: 1;
    }

    .heading-container {
        grid-row: 1;
        display: flex;
        flex-direction: column;
        padding-inline-start: var(--heading-start-padding, 16px);
        padding-inline-end: var(--heading-end-padding, 16px);
        padding-bottom: 0;
        padding-top: 16px;
    }

    .heading-wrapper a:after {
        bottom: 0;
        content: "";
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 1;
    }

    :host([layout="condensed"]) .body {
        gap: 0;
    }

    :host([layout="condensed"]) .footer {
        grid-row: 2;
        grid-column-start: 1;
        grid-column-end: var(--footer-grid-column-end, auto);
        padding-inline-start: 16px;
    }

    :host([layout="condensed"]) .media-wrapper {
        position: relative;
        grid-row: 1 / span 2;
        margin-top: 5px;
    }

    :host([layout="condensed"]) .heading-container {
        padding-top: 0px;
        --heading-end-padding: 12px;
    }

    :host([layout="condensed"]) ::slotted([slot="attribution"]) {
        margin-bottom: 0px
    }

    .icon {
        position: absolute;
        display: inline-flex;
        top: auto;
        bottom: 0;
        justify-content: center;
        align-items: center;
        margin: 0 0 4px 0;
        margin-inline-start: 4px;
    }

    .icon__hidden {
        display: none;
    }

    ::slotted([slot="icon"]) {
        width: var(--icon-size);
        height: var(--icon-size);
        fill: #FFF;
    }

    ::slotted([slot="attribution"]) {
        margin-bottom: 6px
    }

    ::slotted([slot="abstract"]) {
        margin: 2px 0;
    }

    .media-wrapper {
        grid-row: 1;
        grid-column: 2;
        margin-inline-end: var(--media-inline-padding, 16px);
        margin-top: 16px;
    }

    .media {
        display: flex;
        position: relative;
    }

    :host([image-priority]) .heading {
        -webkit-line-clamp: var(--heading-max-lines, 2);
    }

    :host([image-priority]) .body {
        grid-template-columns: 1;
    }

    :host([image-priority]) .media-wrapper {
        grid-row: 1;
        grid-column: span 2;
        margin: 0;
    }

    :host([image-priority]) .heading-container {
        grid-row: 2;
        grid-column: span 2;
        padding-top: 10px;
        padding-inline-start: var(--heading-start-padding, 16px);
    }

    :host([image-priority]) ::slotted([slot="media"]),
    :host([layout="infoPaneSplitHorizontal"]) ::slotted([slot="media"]) {
        border-radius: 0px;
    }

    :host([layout="infoPane"]) .media-wrapper, :host([layout="infoPane1x3y"]) .media-wrapper {
        grid-row: 1;
        grid-column: 1;
        margin-top: 0;
        width: fit-content;
        height: fit-content;
    }

    :host([layout="infoPane"]) .icon, :host([layout="infoPaneSplitVertical"]) .icon, :host([layout="infoPane1x3y"]) .icon {
        display: inline;
        left: 0;
        top: 0;
        margin: 4px 0 0;
        margin-inline-start: 4px;
    }

    :host([layout="infoPaneSplitVertical"]) .icon {
        display: block;
    }

    :host([layout="infoPaneSplitHorizontal"]) .icon {
        bottom: 0px;
    }
    
    :host([layout="infoPaneSplitHorizontal"]) .heading-container,
    :host([layout="infoPane"]) .heading-container, :host([layout="infoPane1x3y"]) .heading-container {
        align-self: end;
    }

    :host([layout="infoPaneSplitHorizontal"]) .body,
    :host([layout="infoPane"]) .body, :host([layout="infoPane1x3y"]) .body {
        height: 100%;
        grid-template-rows: 1fr auto;
    }

    ::slotted([slot="call-to-action"]) {
        width: calc(100% - 32px);
        grid-row: 3;
        z-index: 1;
        grid-column: 1 / span 2;
        margin: 0 16px;
    }

    ::slotted([slot="media"]) {
        border-radius: calc(var(--content-card-corner-radius, 2) * 2px)
    }

    :host([layout="default"]) .has-abstract .abstract {
        display: block;
        padding: 0 16px 16px 16px;
    }

    .abstract {
        position: relative;
        margin: 0;
        font-size: var(--abstract-font-size, var(--type-ramp-base-font-size));
        line-height: var(--abstract-line-height, var(--type-ramp-base-line-height));
        font-weight: 400;
        grid-column: span 2;
        box-sizing: content-box;
        color: ${neutralForegroundHintBehavior.var};
        padding: 0 16px;
    }

    ::slotted([slot="start-actions"]),
    ::slotted([slot="end-actions"]) {
        z-index: 2;
        display: grid;
        gap: 5px;
        align-items: center;
        grid-auto-flow: column;
    }

    ::slotted([slot="call-to-action"]) {
        z-index: 2;
    }

    ::slotted(fluent-button[slot="start-actions"]),
    ::slotted(fluent-button[slot="end-actions"]) {
        color: ${neutralForegroundHintBehavior.var};
        fill: ${neutralForegroundHintBehavior.var};
    }
    
    ::slotted(fluent-button[appearance="stealth"]:not(:hover)), :slotted([slot="hover-actions"]:not(:hover)) {
        background: transparent;
    }

    .heading {
        text-decoration: none;
        outline: none;
        color: ${neutralForegroundRestBehavior.var};
        font-size: var(--heading-font-size, var(--type-ramp-plus-1-font-size));
        line-height: var(--heading-line-height, var(--type-ramp-plus-1-line-height));
        font-weight: 600;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: var(--heading-max-lines, 3);
        white-space: initial;
    }

    .mask {
        display: none;
    }

    .heading:hover,
    .heading:${focusVisible} {
        text-decoration: underline;
    }

    .heading::after {
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    :host([layout="infoPane"]), :host([layout="infoPane1x3y"]) {
        justify-content: flex-end;
        border: none;
    }

    :host(:not([layout="infoPane"])) .has-abstract-footer, :host(:not([layout="infoPane1x3y"])) .has-abstract-footer {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: var(--background-color);
        box-shadow: 0px -25px 15px var(--background-color);
    }

    :host([layout="infoPane"]) .heading-container, :host([layout="infoPane1x3y"]) .heading-container {
        grid-column: 1 / 3;
        z-index: 1;
    }

    :host([layout="infoPane"]) .has-abstract .heading-container, :host([layout="infoPane1x3y"]) .has-abstract .heading-container  {
        grid-area: 2/ 1 / span 2 / auto;
        --heading-start-padding: 16px;
        --heading-end-padding: 0;
        padding-bottom: 12px;
        padding-top: 8px;
        align-self: flex-start;
    }

    :host([layout="infoPane"]) .abstract, :host([layout="infoPane1x3y"]) .abstract, :host([layout="infoPaneSplitHorizontal"]) .abstract  {
        grid-row: 2;
        grid-column: 2;
        color: ${neutralForegroundRestBehavior.var};
        padding: 8px 16px 0 16px;
        align-self: end;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
    }

    :host([layout="infoPane"]) .abstract, :host([layout="infoPane1x3y"]) .abstract  {
        display: none;
    }

    :host([layout="infoPane"]) .has-abstract, :host([layout="infoPane1x3y"]) .has-abstract {
        grid-template-columns: 1fr 1fr;
        gap: 0 10px;
    }

    :host([layout="infoPane"]) .has-abstract .footer, :host([layout="infoPane1x3y"]) .has-abstract .footer {
        min-height: calc(40px - 4px);
    }

    :host([layout="infoPane"]) .has-abstract .abstract, :host([layout="infoPane1x3y"]) .has-abstract .abstract {
        display: -webkit-box;
        align-self: flex-end;
    }

    :host([layout="infoPane"]) .mask, :host([layout="infoPane1x3y"]) .mask {
        display: flex;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: var(--mask-gradient, linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0,0,0,0) 176px));
    }
    
    :host([layout="infoPane1x3y"]) .mask {
        background-image: var(--mask-gradient, linear-gradient(rgba(0, 0, 0, 0), rgba(0,0,0,1) 69px, rgba(0,0,0,1)));
        top: 257px;
    }

    :host([layout="infoPane"]) .has-abstract .has-abstract-footer, :host([layout="infoPane1x3y"]) .has-abstract .has-abstract-footer {
        grid-row: 3;
        grid-column: 2;
        position: inherit;
        align-self: flex-end;
        max-height: 40px;
    }

    :host([layout="infoPane"]) .footer, :host([layout="infoPane1x3y"]) .footer  {
        margin-top: unset;
        grid-row: 2;
        grid-column: 1 / span 2;
        padding-inline-start: 16px;
        padding-inline-end: 16px;
    }


    :host([layout="infoPane"]) ::slotted(msft-attribution[slot="attribution"]), :host([layout="infoPane1x3y"]) ::slotted(msft-attribution[slot="attribution"]) {
        color: ${neutralForegroundRestBehavior.var};
        text-shadow: 0px 0.4px 0.9px rgba(0, 0, 0, 0.13), 0px 0px 2.22px rgba(0, 0, 0, 0.11);
    }


    :host([layout="infoPaneSplitVertical"]) {
        grid-template-columns: 304px 1fr;
        grid-template-rows: auto;
    }

    :host([layout="infoPaneSplitVertical"]) ::slotted([slot="media"]) {
        border-radius: 0px;
    }

    :host([layout="infoPaneSplitVertical"]) .media-wrapper {
        grid-row: 1 / span 2;
        grid-column: 1;
        margin: 0;
    }

    :host([layout="infoPaneSplitVertical"]) .heading-container {
        grid-row: 1;
        grid-column: 2;
        --heading-start-padding: 4px;
        --heading-end-padding: 16px;
        padding-bottom: 0;
        padding-top: 16px;
    }

    :host([layout="infoPaneSplitVertical"]) .footer {
        grid-row: 2;
        grid-column: 2;
        padding-inline-start: 0;
        padding-inline-end: 16px;
        padding-top: 0;
    }

    :host([layout="infoPaneSplitHorizontal"]) .body {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 326px auto auto;
        row-gap: 4px;
    }

    :host([layout="infoPaneSplitHorizontal"]) .media-wrapper {
        grid-column: 1 / span 2;
        margin: 0;
    }

    :host([layout="infoPaneSplitHorizontal"]) .heading-container {
        grid-column: 1;
        grid-row: 2 / span 2;
        --heading-start-padding: 16px;
        --heading-end-padding: 0;
        padding-bottom: 12px;
        padding-top: 12px;
    }

    :host([layout="infoPaneSplitHorizontal"]) .footer {
        grid-column: 2;
        grid-row: 3;
        box-shadow: none;
    }

    :host([layout="infoPaneSplitHorizontal"]) .abstract {
        color: inherit;
        align-self: inherit;
        padding: 12px 16px 0 16px;
    }

    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }

    :host([layout="infoPane1x3y"]) .background-image {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 136px;
    }

    .background-image ::slotted(img) {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    :host([layout="infoPane1x3y"]) ::slotted([slot="content-indicator"]),
    :host([layout="infoPane"]) ::slotted([slot="content-indicator"]),
    .media-wrapper ::slotted([slot="content-indicator"]) {
        position: absolute;
        top: 8px;
        z-index: 1;
    }

    ::slotted([slot="content-indicator"]) {
        margin-bottom: 26px;
        align-self: flex-start;
    }

`.withBehaviors(neutralForegroundHintBehavior, neutralForegroundRestBehavior, new DirectionalStyleSheetBehavior(ltrStyles, rtlStyles), forcedColorsStylesheetBehavior(css `
            .heading {
                color: ${SystemColors.LinkText};
                background: ${SystemColors.ButtonFace};
            }
            .abstract {
                color: ${SystemColors.ButtonText};
            }
            .icon {
                background-color: #000;
                height: fit-content;
            }
            :host([layout="infoPane"]) .abstract,
            :host([layout="infoPane1x3y"]) .abstract,
            :host([layout="infoPaneSplitHorizontal"]) .abstract {
                color: ${SystemColors.ButtonText};
                background: ${SystemColors.ButtonFace};
            }
            .footer,
            .start-actions,
            .end-actions,
            ::slotted([slot="start-actions"]),
            ::slotted([slot="end-actions"]) {
                background: ${SystemColors.ButtonFace};
                color: ${SystemColors.ButtonText};
                fill: currentcolor;
            }
            :host([layout="infoPane"]) .mask,
            :host([layout="infoPane1x3y"]) .mask {
                background-image: none;
            }
            :host([layout="infoPane"]) .has-abstract .footer,
            :host([layout="infoPane1x3y"]) .has-abstract .footer,
            :host([layout="infoPane"]) .footer,
            :host([layout="infoPane1x3y"]) .footer,
            :host(:not([layout="infoPane"])) .has-abstract-footer,
            :host(:not([layout="infoPane1x3y"])) .has-abstract-footer {
                background: ${SystemColors.ButtonFace};
                box-shadow: none;
            }
            ::slotted(fluent-button[appearance="stealth"]:not(:hover)) {
                background: ${SystemColors.ButtonFace};
            }
        `));
